export default __webpack_public_path__ + "static/media/gridImg3.a25450b8.jpg";